module.exports = __webpack_public_path__ + "static/media/le-malin.9852c473.png";